/* Un singur handler delegat: funcționează și după filtrare / reîncărcarea secțiunilor. */
(function () {
  'use strict';
  function selectColor(link) {
    var card = link.closest('.product-card');
    if (!card) return;
    card.dataset.colorSelected = link.dataset.colorName;
    card.querySelectorAll('[data-card-swatch]').forEach(function (swatch) {
      swatch.setAttribute('aria-pressed', String(swatch === link));
    });
    card.querySelectorAll('.product-card__media, .product-card__title a, a.product-card__add').forEach(function (target) {
      target.href = link.href;
    });
    var media = card.querySelector('.product-card__media');
    if (!media) return;
    var image = media.querySelector('img:not(.product-card__media-alt)');
    var empty = media.querySelector('.product-card__variant-empty');
    if (!empty) {
      empty = document.createElement('span');
      empty.className = 'product-card__variant-empty';
      media.appendChild(empty);
    }
    if (link.dataset.colorImage) {
      if (!image) {
        image = document.createElement('img');
        media.prepend(image);
      }
      image.removeAttribute('srcset');
      image.src = link.dataset.colorImage;
      image.alt = link.dataset.colorAlt || link.dataset.colorName;
      image.hidden = false;
      empty.hidden = true;
    } else {
      if (image) image.hidden = true;
      empty.textContent = 'Fotografie indisponibilă pentru ' + link.dataset.colorName;
      empty.hidden = false;
    }
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-card-swatch]');
    if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    selectColor(link);
  });
  document.addEventListener('keydown', function (event) {
    var link = event.target.closest('[data-card-swatch]');
    if (!link || event.key !== ' ') return;
    event.preventDefault();
    selectColor(link);
  });
})();
